<template>
    <div class="wrapper">
        <header class="header">
            <div class="header__contact-form">
                <div id="contact-form"></div>
            </div>
            <div class="header__msg">
                <span class="header__msg-primary">Let us know how we can help!</span>
                <span class="header__msg-sencondary">Send us a message</span>
            </div>
        </header>
        <section class="location">
            <div class="location__map">
                <img :src="require('@/assets/map1.png')" alt="map" class="location__map-photo">
            </div>
            <div class="location__address">
                <div class="location__detail">
                    <h3 class="location__detail-title">Location</h3>
                    <span class="location__detail-info">No.20,22 Alan Pya Pagoda Road, Shine Office Tower (B),</span>
                    <span class="location__detail-info">Mingalar Taung Nyunt Township</span>
                    <span class="location__detail-info">Yangon</span>
                </div>
                <div class="location__detail">
                    <h3 class="location__detail-title">Phone</h3>
                    <span class="location__detail-info">+95 9791029719</span>
                    <span class="location__detail-info">+95 9408194400</span>
                    <span class="location__detail-info"></span>
                </div>
                <div class="location__detail">
                    <h3 class="location__detail-title">Email</h3>
                    <span class="location__detail-info">contact@magnifymyanmar.com</span>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
	export default {
		name: "ContactUs",
		mounted() {
			let el = document.getElementById("contact-form");
			window.typeformEmbed.makeWidget(el, "https://ninitun.typeform.com/to/WkxwQZtl", {
				hiddenFooter: true,
				hiddenHeaders: true,
				opacity: 0
			});
			let script = document.createElement("script");
			script.src = 'https://maps.googleapis.com/maps/api/js?key=AIzaSyDM_0FZMRiUT_RyPVcQ1dsQxRURXH-aSm8&callback=initMap';
			script.defer = true;
			document.head.appendChild(script);

			window.initMap = function(){
				let map = new google.maps.Map(document.getElementById("map"), {
					center: { lat: 16.806301, lng: 96.154658 },
					zoom: 8,
				});
            }
		}
	}
</script>

<style scoped>
    @import '../../public/css/bootstrap.min.css';
    @import '../../public/css/bindez.css';
    @import '../../public/css/bindez-custom2.css';

    @font-face {
        font-family: 'icomoon';
        src: url('../../public/fonts/icomoon.eot');
        src: url('../../public/fonts/icomoon.eot') format('embedded-opentype'),
        url('../../public/fonts/icomoon.ttf') format('truetype'),
        url('../../public/fonts/icomoon.woff') format('woff'),
        url('../../public/fonts/icomoon.svg') format('svg');
        font-weight: normal;
        font-style: normal;
    }

    /* new style */
    *,
    *::after,
    *::before{
        box-sizing: border-box;
    }

    body{
        margin: 0;
        font-family: 'Roboto', sans-serif;
    }

    h1,h2,h3,h4,h5,h6{
        margin: 0;
    }


    .header{
        margin-top: 80px;
        display: flex;
        padding: 20px 100px;
        background-image: linear-gradient(to right bottom,rgba(0,124,197,.5),rgba(0,124,197,.5)),url("../assets/contactusheader.jpg");
        background-size: cover;
        background-position: center;
        align-items: center;
        flex-flow: row wrap;
        justify-content: space-between;
    }

    .header__msg{
        font-weight: 500;
        color: #fff;
        line-height: 2;
    }

    .header__msg-primary{
        display: block;
        font-size: 25px;
    }

    .header__msg-sencondary{
        display: block;
        font-size: 20px;
    }

    .header__contact-form{
        /* margin-right: 95px; */
        height: 350px;
        flex: 0 0 45%;
        background-color: #fff;
    }

    .header__msg{
        flex: 0 0 45%;
    }

    .location{
        padding: 20px 100px;
        display: flex;
        flex-flow: row wrap ;
        justify-content: space-between;
    }

    .location__map{
        flex: 0 0 45%;
    }


    .location__map-photo{
        width: 100%;
        height: 100%;
    }

    .location__address{
        padding: 50px 0;
        flex: 0 0 45%;
        display: flex;
        flex-direction: column;
        justify-content: center;
    }

    .location__detail{
        line-height: 32px;
    }

    .location__detail-info, .location__detail-title{
        color: #5e7582;
    }

    .location__detail-info{
        display: block;
        font-size: 18px;
        /*font-weight: 300;*/
    }

    .location__detail-title{
        font-size: 25px;
        font-weight: 700;
        margin-bottom: 10px;
    }

    .location__address div:not(:last-child){
        margin-bottom: 20px;
    }

    @media screen and (max-width: 400px){
        .header__msg-primary{
            font-size: 20px;
        }

        .header__msg-sencondary{
            font-size: 15px;
        }
    }
    @media screen and (max-width: 800px){
        .header, .location{
            padding: 25px;
        }

        .header > div:not(:last-child), .location > div:not(:last-child){
            margin-top: 20px;
        }

        .location__address{
            padding: 0;
        }

        .header > .header__contact-form, .location > .location__map{
            order: 1;
            margin-right: 0;
        }

        .header > *, .location > * {
            flex: 0 0 100%;
        }
    }

    #contact-form{
        width: 100%;
        height: 100%;
    }
    
</style>
